<div
    role="dialog"
    class="agpr-takeOverPanel"
    [ngClass]="styleClass"
    [@overlayAnimation]="overlayAnimation"
    (clickOutside)="clickOutside($event)"
    [clickOutsideEnabled]="overlay"
    [exclude]="clickOutsideExcluded"
    [excludeBeforeClick]="true"
    (@overlayAnimation.start)="overlayAnimationStart($event)"
    [style.zIndex]="zIndex"
    [style.top]="navBarHeight"
    [id]="id"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.aria-modal]="true"
    [attr.aria-label]="(ariaLabel || header ) | localize"
>
    <div
        [attr.id]="id ? (id + '_takeOverPanel_container') : null"
        class="agpr-takeOverPanel-container"
    >
        @if (focusCloseButton) {
            <agpr-button
                [id]="id + '_focusCloseButton'"
                class="agpr-takeOverPanel-focusClose"
                [style.width]="(100 - width) + '%'"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-xmark"
                ariaLabel="close"
                (click)="close()"
            ></agpr-button>
        }

        <div
            [attr.id]="id ? (id + '_takeOverPanel_center') : null"
            class="agpr-takeOverPanel-center"
            [ngClass]="{
                'agpr-takeOverPanel-center--whiteBg': whiteBg,
                'agpr-takeOverPanel-center--fullWidth': fullWidth || !focusCloseButton
            }"
            [style.width]="width + '%'"
            [@slideInOutAnimation]="slideInOutAnimation"
            (@slideInOutAnimation.done)="animationDone($event)"
        >
            <button
                *ngIf="backToButtonString"
                class="agpr-contentToggle"
                (click)="close()"
            >
                <span
                    class="agpr-contentToggle-arrow--reverse agpr-i-double-arrow"
                    aria-hidden="true"
                ></span>
                <span class="agpr-contentToggle-message">
                    {{ backToButtonString | localize }}
                </span>
                <span class="agpr-contentToggle-bar"></span>
            </button>
            <div
                *ngIf="arrowBackBar"
                class="agpr-takeOverPanel-arrowBackBar"
            >
                <agpr-button
                    class="agpr-takeOverPanel-arrowBackButton"
                    [style]="buttonTypes.icon"
                    icon="fa-solid fa-angles-right"
                    [tooltip]="arrowBackBar | localize"
                    [initiallyFocusable]="false"
                    (click)="close()"
                ></agpr-button>
            </div>
            <h2
                *ngIf="header"
                [id]="id + '_header'"
                class="agpr-takeOverPanel-header"
            >
                <ng-container *ngTemplateOutlet="takeOverHeaderStart"></ng-container>
                <span *ngIf="headerIcon" [ngClass]="'agpr-takeOverPanel-headerIcon ' + headerIcon" aria-hidden="true"></span>
                <span
                    #takeOverPanelHeader
                    tabindex="0"
                    cdkFocusInitial
                    [id]="id + '_takeOverPanel_headerTitle'">
                    {{ header | localize }}
                </span>
                @if (subHeader) {
                    <span class="agpr-takeOverPanel-subHeader" [innerHTML]="subHeader | localize"></span>
                }
                @if (showProgressBar) {
                    <div
                        [attr.id]="id ? (id + '_progressBar_container') : null"
                        class="agpr-takeOverPanel-header-progressBar"
                    >
                        <div
                            [attr.id]="id ? (id + '_progressBar_info') : null"
                            class="agpr-takeOverPanel-header-progressBar-info"
                        >
                            <span [attr.id]="id ? (id + '_progressBar_label') : null">{{ 'Common.contentLibrary.manageDialog.Storage.Label' | localize }}</span>
                                <span
                                    class="agpr-takeOverPanel-header-progressBar-info-icon fa-regular fa-circle-arrow-up fa-duotone"
                                    id="contentLibraryIcon"
                                    (mouseenter)="progressBarMouseEnter.emit($event)"
                                ></span>
                            <p-progressBar
                                [attr.id]="id + '_progressBar'"
                                [value]="progressValue"
                                [showValue]="true"
                                [agprTooltip]="(progressValue | number:'1.1-1') + '%' | localize"
                                tooltipPosition="top"
                            ></p-progressBar>
                            <span
                                [id]="id + '_progressBar_description'"
                                class="agpr-takeOverPanel-header-progressBar-info-description"
                            >{{ 'Common.contentLibrary.progressBar' | localize:{ used: used, total: total } }}</span>
                        </div>
                    </div>
                }
            </h2>

            <h2
                *ngIf="splitHeader"
                class="agpr-takeOverPanel-header"
                tabindex="0"
                cdkFocusInitial
            >
                <i
                    *ngIf="splitHeader?.icon"
                    class="agpr-takeOverPanel-header-icon {{splitHeader?.icon}}"
                ></i>
                <span
                    #takeOverPanelHeader
                    [innerHTML]="splitHeader?.initialText | localize"
                    [id]="id + '_takeOverPanel_splitHeaderTitle'"
                >
                </span>
                <div
                    class="agpr-takeOverPanel-header-value"
                    [ngClass]="{
                        'agpr-takeOverPanel-header-loading': splitHeader?.loading
                    }">
                    <div
                        *ngIf="splitHeader?.loading"
                        [agprLoading]="true"
                        [agprInlineLoadingIndicator]="true"
                        [loadingSmallIndicator]="true"
                    ></div>
                    <span
                        *ngIf="!splitHeader?.loading"
                        #takeOverPanelHeader
                        [innerHTML]="splitHeader?.value | localize"
                    >
                    </span>
                </div>
                <span
                    #takeOverPanelHeader
                    [innerHTML]="splitHeader?.endText | localize"
                >
                </span>
            </h2>
            <h2
                *ngIf="invisibleHeader"
                class="u-srOnly"
            >
                {{ invisibleHeader | localize }}
            </h2>

            @if (noScroll) {
                <div
                    [attr.id]="id ? (id + '_takeOverPanel_content') : null"
                    class="agpr-takeOverPanel-content"
                    [ngClass]="{
                        'agpr-takeOverPanel-content-paddingTop': !backToButtonString && showTopPadding && !noPadding,
                        'agpr-takeOverPanel-content-noPadding': noPadding,
                        'agpr-takeOverPanel-content--fullWidth': fullWidth,
                        'agpr-takeOverPanel-content--fullHeight': fullHeight || coverNav,
                        'agpr-takeOverPanel-content--whiteBg': whiteBg
                    }"
                >
                    <ng-container *ngTemplateOutlet="noScrollContent"></ng-container>
                </div>
            } @else {
                <agpr-scroll-panel [id]="id ? (id + '_takeOverPanel_scrollPanel') : null">
                    <div
                        [attr.id]="id ? (id + '_takeOverPanel_content') : null"
                        class="agpr-takeOverPanel-content"
                        [ngClass]="{
                            'agpr-takeOverPanel-content-paddingTop': !backToButtonString && showTopPadding && !noPadding,
                            'agpr-takeOverPanel-content-noPadding': noPadding,
                            'agpr-takeOverPanel-content--fullWidth': fullWidth,
                            'agpr-takeOverPanel-content--fullHeight': fullHeight || coverNav,
                            'agpr-takeOverPanel-content--whiteBg': whiteBg
                        }"
                    >
                        <ng-content></ng-content>
                    </div>
                </agpr-scroll-panel>
            }

            @if (showFooter) {
                <div
                    [attr.id]="id ? (id + '_takeOverPanel_footer') : null"
                    class="agpr-takeOverPanel-footer"
                    [ngClass]="{'agpr-takeOverPanel-footer-marginRight': hasSideTabs }"
                    role="group"
                    [attr.aria-label]="'Common.takeOverPanel.footer.controls' | localize"
                >
                    @if (footerContext) {
                        <h3 class="u-srOnly">{{ 'footerActions' | localize: {context: footerContext} }}</h3>
                    }
                    <div
                        [attr.id]="id ? (id + '_takeOverPanel_footerLeft') : null"
                        class="agpr-takeOverPanel-footerLeft"
                    >
                        <ng-container *ngTemplateOutlet="takeOverFooterLeft"></ng-container>
                    </div>
                    <div
                        [attr.id]="id ? (id + '_takeOverPanel_footerRight') : null"
                        class="agpr-takeOverPanel-footerRight"
                    >
                        <ng-container *ngTemplateOutlet="takeOverFooterRight"></ng-container>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
